'use strict'

var Backbone = require('backbone')
var Marionette = require('marionette')
var App = require('app')

var Show = require('./show')

var StyleGuideModule = function () {
  var Router = Marionette.AppRouter.extend({
    appRoutes: {
      'styleguide': 'showStyleGuide'
    }
  })

  // 
  var API = {
    showStyleGuide: function () {
      new Show()
    }
  }

  // fire this up on an global app event
  new Router({ controller: API })
}

module.exports = StyleGuideModule



// WEBPACK FOOTER //
// ./js/modules/styleguide/index.js